import type { IntlShape } from 'react-intl';
import type { SubscriptionFeature } from '@alltrails/types/SubscriptionFeature';
import trailConditionsSrc from './images/trail-conditions-thumb.avif';

const trailConditions = (intl: IntlShape): SubscriptionFeature => ({
  headline: intl.formatMessage({ defaultMessage: 'Trail Conditions' }),
  subheadline: intl.formatMessage({ defaultMessage: 'Plan for trail-specific weather, snow depth, and more' }),
  thumbnailImage: trailConditionsSrc.src
});

export default trailConditions;
